import styled from "styled-components";
import InnerMarkdownHTML from "../../../../../base/text/inner-markdown-HTML/index.js";
import { BannerCampaignVertical as BannerCampaignVerticalDefault } from "../../../../banners/banner-campaign-vertical/index.js";
import BenefitsCardDefault from "../../../../cards/benefits-card/views/desktop/index.js";
import ProductCardDefault from "../../../../cards/product-card/views/desktop/index.js";
import Slider from "../../../../../structures/others/slider/index.js";
import { generateBreakpointsItem } from "../../../../../structures/others/slider/utils.js";
import { BoxShadow } from "../../../../../../styles/common/mixins/box-shadow.styled.js";
import { FlexMixin, FontMixin } from "../../../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../../../styles/common/mixins/logical.styled.js";
export const CarouselProductWrapper = styled.div.withConfig({
    displayName: "styled__CarouselProductWrapper",
    componentId: "sc-5764ffd-0"
})`
	display: inline-flex;
	height: calc(100% - 40px);
	overflow: visible;
	width: 100%;
	${({ $isTablet  })=>$isTablet && `flex-direction: column;`}
`;
export const ProductCard = styled(ProductCardDefault).withConfig({
    displayName: "styled__ProductCard",
    componentId: "sc-5764ffd-1"
})``;
export const CarouselProductBox = styled.div.withConfig({
    displayName: "styled__CarouselProductBox",
    componentId: "sc-5764ffd-2"
})`
	overflow: visible;
	position: relative;
	padding-left: 24px;
	padding-right: 24px;
	padding: 0 2px 2px 2px;
	width: 100%;
	min-height: 100%;

	&.has-benefits,
	&.has-banner {
		.splide {
			&:not(.is-initialized),
			&.is-initialized:not(.is-active) {
				${generateBreakpointsItem({
    xxl: 3,
    xl: 2,
    lg: 1
}, 4)}
			}
		}
	}

	&.has-benefits {
		width: calc(100% - 320px);
		padding: 0 0 0 32px;
		margin: 2px 0 2px 0;
		min-height: 100%;
		width: calc(100% - 320px);
		padding: 0 0 0 40px;

		&.is-tablet {
			margin: 0 0 18px 0;
			width: 100%;
			padding: 0;
		}
	}

	&.has-banner {
		width: calc(100% - 375px);
		padding: 0 0 0 40px;
		min-height: 100%;

		${ProductCard} {
			min-width: unset;
		}

		&.is-tablet {
			width: 100%;
			padding: 0;

			${ProductCard} {
				max-width: unset;
				margin: auto;
			}
		}
	}
`;
export const ProductsSlider = styled(Slider).withConfig({
    displayName: "styled__ProductsSlider",
    componentId: "sc-5764ffd-3"
})`
	height: 100%;

	.splide__track {
		padding-bottom: 16px;
		height: 100%;
	}

	button.splide__pagination__page {
		&.is-active {
			&::before {
				width: 100%;
				${BorderRadius({
    all: '8px'
})};
				height: 100%;
				background-color: ${({ theme  })=>theme.colors.primary.light};
			}
		}
	}

	.splide__arrows .splide__arrow {
		${FontMixin({
    size: 'larger',
    height: 'base'
})}

		&:hover {
			color: ${({ theme  })=>theme.colors.primary.base};
		}
	}

	.splide__arrows .splide__arrow[disabled] {
		opacity: 0;
		height: 0;
		transition: opacity 0.5s;

		& > i {
			font-size: 0;
		}
	}

	.splide__arrows .splide__arrow--prev {
		margin-left: -18px;
	}

	.splide__arrows .splide__arrow--next {
		margin-right: -18px;
	}

	.splide__arrows .splide__arrow {
		width: 36px;
		height: 36px;
		background-color: ${({ theme  })=>theme.colors.white.base};
		margin-left: -18px;
		${FlexMixin({
    justify: 'center',
    align: 'center'
})};
		${BorderRadius({
    all: '50%'
})}
		${BoxShadow}
		opacity: 1;

		transition: opacity 0.5s ease-in-out;

		& > i {
			font-size: 12px;
		}
	}

	.splide__pagination li {
		height: 12px;
	}

	.splide {
		&:not(.is-initialized),
		&.is-initialized:not(.is-active) {
			${({ $visibleCardsCount  })=>$visibleCardsCount ? generateBreakpointsItem({
        xxl: 4,
        xl: 3,
        lg: 2
    }) : generateBreakpointsItem({
        '2xl': 4,
        xl: 3,
        lg: 2
    })}
		}
	}
`;
export const TitleCarouselWrapper = styled.div.withConfig({
    displayName: "styled__TitleCarouselWrapper",
    componentId: "sc-5764ffd-4"
})`
	margin-bottom: 20px;
	text-align: center;
`;
export const TitleCarousel = styled.h2.withConfig({
    displayName: "styled__TitleCarousel",
    componentId: "sc-5764ffd-5"
})`
	${FlexMixin({
    align: 'center',
    justify: 'center'
})}
	margin-bottom: 0;

	& a {
		color: ${({ theme  })=>theme.colors.grays.darker};
		font-family: ${({ theme  })=>theme.font.family.secondary};
		${FontMixin({
    size: 'largest',
    weight: 'medium',
    height: 'largest'
})}
		padding: 0 8px;
		position: relative;
	}
`;
export const SubtitleCarousel = styled(InnerMarkdownHTML).withConfig({
    displayName: "styled__SubtitleCarousel",
    componentId: "sc-5764ffd-6"
})`
	color: ${({ theme  })=>theme.colors.grays.dark};
	${FontMixin({
    size: 'base',
    weight: 'light',
    height: 'base'
})}
	margin-bottom: 0;
	margin-top: 4px;
`;
export const CardSkeletonWrapper = styled.div.withConfig({
    displayName: "styled__CardSkeletonWrapper",
    componentId: "sc-5764ffd-7"
})`
	padding: 0px 2px;
`;
export const BannerCampaignVertical = styled(BannerCampaignVerticalDefault).withConfig({
    displayName: "styled__BannerCampaignVertical",
    componentId: "sc-5764ffd-8"
})`
	margin-bottom: ${({ $isBanner  })=>$isBanner ? '18px' : ''};
	margin-top: ${({ $isBanner  })=>$isBanner ? '2px' : ''};

	&.is-tablet {
		margin-bottom: 20px;
	}
`;
export const BenefitsCard = styled(BenefitsCardDefault).withConfig({
    displayName: "styled__BenefitsCard",
    componentId: "sc-5764ffd-9"
})`
	margin-bottom: 18px;
`;

//# sourceMappingURL=styled.js.map